<template>
  <div class="Answer">
    <div class="banner">
      <img class="tit" src="/subject/authentication/banner.png" alt="">
    </div>
    <div class="box1">
      <img class="tit" src="/subject/authentication/tit1.png" alt="">
      <div v-if="!isAuth">

        <input class="input1" v-model="form.Name" type="text" placeholder="请输入姓名">
        <input class="input2" v-model="form.CredentialsNum" type="text" placeholder="请输入身份证号">
        <button class="pushBtn" @click="openRedPacket"></button>
      </div>
      <div v-else>
        <img class="imgSuccess" src="/subject/authentication/success.png" />
        <p class="sucp">已完成认证并领取奖励</p>
      </div>
    </div>
    <div class="box2">
      <div>
        <img class="reward" src="/subject/authentication/reward.png" />
        <p class="yyyp">
          完成资料即入账，无附加条件
          <br />
          提交后可继续交易，盈利即可提现
        </p>
        <button class="btnTrade" @click="goTrade"></button>
      </div>
    </div>
    <div class="box3">
      <div>
        <img class="tit" src="/subject/authentication/rules.png" />
        <p class="wwwd">
          1. 完成基础认证后，即刻获得50美元 赠金奖励。
          <br />
          2. 奖励变动详情请查看：
          <br />
          &nbsp;&nbsp;50美元赠金：App — 我的 — 赠金奖励
        </p>
      </div>
    </div>
    <p class="hhh">想要更多福利活动？</p>
    <div class="box4">
      <p>
        ·&nbsp;下载红狮官方App
        <br />
        ·&nbsp;多重新老用户福利
        <br />
        ·&nbsp;让您越交易越省钱
      </p>
      <img class="request" @click="goRequest" src="/subject/authentication/request.png" />

    </div>
    <p class="bbb">
      注意：信息收集用于保护您的账户安全，不会在未经允许下作为 其他用途
    </p>
    <loginDialog :loginDialogShow="loginDialogShow" @loginDialogShowChange="loginDialogShowChange_this($event)" />
  </div>

</template>

<script>
import { queryUserInfo, postBaseCheck } from '@/apis/user';
import loginDialog from '../components/loginDialog/wap/loginDialog.vue';
import Qrcode from '@/component/QrCode/index.vue'
import { mapState } from "vuex";
import { setToken } from "@/utils/cookies";
import { getIMEI } from "@/utils/IMEI";
import { getUrlParam } from '@/utils/tools'

export default {
  name: 'authentication',
  data() {
    return {
      loginDialogShow: false,
      form: {
        Name: '',
        CredentialsNum: ''
      },
      screenWidth: null,
      // 是否已登录
      isLogin: false,
      // 是否已认证
      isAuth: false,
    }
  },
  components: {
    loginDialog,
    Qrcode,
  },
  computed: {
    ...mapState('common', {
      live800UrlUc: 'live800UrlUc',
      androidDownloadUrl: 'androidDownloadUrl',
      iosMt5DownloadUrl: 'iosMt5DownloadUrl',
    })
  },
  created() {
    // 传给App.vue,不展示tabbar
    this.$emit('controlShow', true);

    // 获取token
    const accessKey = getUrlParam('token_subject') || getUrlParam('accessKey') || window.localStorage.getItem('token_subject');

    if (accessKey) {
      setToken(accessKey);
      this.isLogin = true;
      this.getUserInfo();
    }
  },
  methods: {
    getUserInfo() {
      queryUserInfo().then(res => {
        if (res.jfUser.authenticationMethod === '1') {
          this.isAuth = true;
        }
      }).catch(() => {
        this.isLogin = false;
      })
    },
    goTrade() {
      if (!this.isAuth) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else {
        const u = navigator.userAgent;
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.gotoTrade();
        } else if (isiOS) {
          window.webkit.messageHandlers.gotoTrade.postMessage("1")
        }
      }
    },
    openRedPacket() {
      if (!this.isLogin) {
        const u = navigator.userAgent;
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.gotoLogin();
        } else if (isiOS) {
          window.webkit.messageHandlers.gotoLogin.postMessage("1")
        }
      } else {
        const params = {
          name: this.form.Name,
          credentialsType: '1',
          credentialsNum: this.form.CredentialsNum,
          issueCountry: '1',
          clientId: getIMEI(),
          fromType: 'wap',
        }
        postBaseCheck(params).then(res => {
          this.$message.success(res)
          this.isAuth = true;
        })
      }
    },
    loginDialogShowClick() {
      this.loginDialogShow = true
    },
    loginDialogShowChange_this(value) {
      this.loginDialogShow = value
    },
    // 返回上级页面
    goback() {
      window.location.href = window.location.origin;
    },
    goRequest() {
      window.open(
        this.live800UrlUc
      );
    },
  }
}
</script>

<style lang="less" scoped>
.Answer {
  width: 100%;
  height: auto;
  background: url(/subject/authentication/bg.png) no-repeat;
  background-size: 100% 100%;

  .banner {
    margin-bottom: 20px;

    img {
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 300px
    }
  }

  .box1 {
    width: 342px;
    height: 250px;
    background: url(/subject/authentication/box1.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding-top: 10px;

    .tit {
      display: block;
      margin: 0 auto;
      width: 180px;
      height: 30px;
    }

    .imgSuccess {
      width: 132px;
      display: block;
      margin: 0 auto;
      height: 112px;
      margin-top: 16px;
      margin-bottom: 14px;
    }

    .sucp {
      color: #fe842b;
      text-align: center;
      font-weight: bold;
    }

    .input1 {
      color: #fe8367;
      width: 76%;
      border: none;
      height: 50px;
      box-sizing: border-box;
      display: block;
      margin: 0 auto;
      margin-top: 20px;
      padding-left: 50px;
      background-size: 26px 26px;
      background-color: #ffe6e1;
      background-image: url(/subject/authentication/icon1.png);
      background-repeat: no-repeat;
      background-position: 10px center;

    }

    .input2 {
      color: #fe8367;
      width: 76%;
      border: none;
      height: 50px;
      box-sizing: border-box;
      display: block;
      margin: 0 auto;
      margin-top: 20px;
      padding-left: 50px;
      background-size: 26px 26px;
      background-color: #ffe6e1;
      background-image: url(/subject/authentication/icon2.png);
      background-repeat: no-repeat;
      background-position: 10px center;
    }

    .pushBtn {
      width: 225px;
      border: none;
      height: 45px;
      display: block;
      margin: 0 auto;
      margin-top: 10px;
      background-size: 100% 100%;
      background-image: url(/subject/authentication/pushBtn.png);
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  .box2 {
    width: 330px;
    height: 170px;
    position: relative;
    margin: 0 auto;
    margin-top: 10px;
    text-align: center;
    padding-top: 30px;
    background-size: 100% 100%;
    background-image: url(/subject/authentication/box2.png);
    background-position: center center;

    .reward {
      display: block;
      margin: 0 auto;
      width: 284px;
      height: 85px;
    }

    .yyyp {
      color: #fe842b;
      font-size: 13px;
      text-align: left;
      padding-left: 28px;
      margin-top: 15px;
    }

    .wwwd {
      font-size: 13px;
      text-align: left;
      padding-left: 20px;
      width: 92%;
      line-height: 20px;
      margin-top: 0px;
    }

    .btnTrade {
      right: 18px;
      width: 84px;
      bottom: 35px;
      height: 31px;
      border: none;
      position: absolute;
      background-size: 100% 100%;
      background-image: url(/subject/authentication/btnTrade.png);
      background-position: center center;
    }
  }

  .box3 {
    width: 325px;
    height: 240px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    padding-top: 10px;
    background-size: 100% 100%;
    background-image: url(/subject/authentication/box3.png);
    background-position: center center;

    .tit {
      display: block;
      margin: 0 auto;
      width: 197px;
      height: 33px;
      margin-bottom: 20px;
    }

    p {
      width: 90%;
      font-size: 13px;
      margin-top: 0px;
      text-align: left;
      line-height: 20px;
      padding-left: 20px;
    }
  }

  .hhh {
    color: #ffdea2;
    width: 100%;
    font-size: 17px;
    box-sizing: border-box;
    text-align: left;
    font-weight: 700;
    padding-left: 33px;
    margin-bottom: 8px;
    margin-top: 10px;
  }

  .box4 {
    width: 100%;
    height: 100px;
    margin: 0;
    position: relative;

    p {
      color: #fff4e1;
      width: 100%;
      font-size: 14px;
      box-sizing: border-box;
      text-align: left;
      line-height: 20px;
      padding-left: 31px;
    }

    .ios {
      right: 110px;
      bottom: 54px;
      position: absolute;
      width: 66px;

    }

    .iosp {
      right: 132px;
      bottom: 35px;
      position: absolute;
      color: #fff;
    }

    .and {
      right: 30px;
      bottom: 54px;
      position: absolute;
      width: 66px;
    }

    .andp {
      right: 37px;
      bottom: 35px;
      position: absolute;
      color: #fff;
    }
    .request {
      display: block;
      margin: 0 auto;
      width: 40%;
      height: auto;
      position: absolute;
      top: 6%;
      right: 10%;
    }
  }

  .bbb {
    color: #ffb477;
    width: 80%;
    font-size: 13px;
    text-align: left;
    padding-bottom: 30px;
    padding-left: 43px;
  }
}
</style>